/**
 * Builds an X-Caller header identifying this deployment on outbound
 * server-side requests to the Sibcy Cline API, so API-side logs and Sentry
 * can attribute traffic to a specific site, branch, and deployment
 * (e.g. a stale Vercel preview hitting the staging API).
 *
 * Returns an empty object in the browser: the Vercel git env vars only
 * exist server-side, and client-side calls are proxied same-origin where
 * the Referer already identifies the caller.
 *
 * Example value:
 *   sibcy-website; env=preview; branch=calculators; sha=edeac50e; url=site-git-calculators-team.vercel.app
 *
 * @returns Object
 */
export const callerIdHeaders = () => {
  if (typeof window !== 'undefined') return {};

  const branch = process.env.VERCEL_GIT_COMMIT_REF;
  const sha = process.env.VERCEL_GIT_COMMIT_SHA;
  const url = process.env.VERCEL_URL;
  // Off-Vercel (local dev), fall back to the OS username so "who on the team
  // is hitting the staging API?" stays answerable.
  const user = !url && process.env.USER;

  const parts = [
    'sibcy-website',
    `env=${process.env.NEXT_PUBLIC_VERCEL_ENV || 'local'}`,
    branch && `branch=${branch}`,
    sha && `sha=${sha.slice(0, 8)}`,
    url && `url=${url}`,
    user && `user=${user}`
  ].filter(Boolean);

  return { 'X-Caller': parts.join('; ') };
};
